import React, {useEffect, useRef} from 'react';
import { StyledFullRealityScroll } from './StyledFullRealityScroll';
import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const FullRealityScroll = () => {
  const fixedEl = useRef(null)
  const scrollerEl = useRef(null)

  useEffect(() => {
    
    gsap.to('.intro--full .parallax--wrap',{
      scrollTrigger:{
        scrub: 0.5,
        trigger: '.intro--full',
        start: 'top center'
      },
      y: '-50%'
    })
    gsap.to('.outro--full .parallax--wrap',{
      scrollTrigger:{
        scrub: 0.5,
        trigger: '.outro--full',
        start: 'top center'
      },
      y: '-100%'
    })
    ScrollTrigger.create({
      trigger: '.center--full',
      start: 'center center',
      pin: true,
      id: 'full-reality',
      scrub: 1,
      toggleActions: 'play play reverse reverse',
      onEnter: () => {
        gsap.to('.outside',{opacity: .25, duration: .75})
      },
      onLeave: () => {
        gsap.to('.outside',{opacity: 1, duration: .75})
      },
      onEnterBack: () => {
        gsap.to('.outside',{opacity: .25, duration: .75})
      },
      onLeaveBack: () => {
        gsap.to('.outside',{opacity: 1, duration: .75})
      },
      onUpdate: self => {
        var valY = Math.floor(self.progress * 100)
        gsap.to('.scroller--heading', {y: `-${valY >= 80 ? 80 : valY}%`})
      }
    })
  
    return () => {
      ScrollTrigger.getById('full-reality').kill();
    }
  },[]);

  return (
    <React.Fragment>
      {
       
        <StyledFullRealityScroll>
          <div className="intro--full outside">
            <h5 className="big--title">For those who think this reality, right here, right now, can’t be it. That there has to be something more. </h5>
            <div className="parallax--wrap">
              
            </div>
          </div>
          <div className="center--full" >
            <div className="scroll-mask--full">
              <h3 className="md--title" ref={fixedEl}>More &nbsp;</h3>
              <h3 className="md--title change">
                <div className="scroller--heading" ref={scrollerEl}>
                  <span>engaging</span>
                  <span>immersive</span>
                  <span>competitive</span>
                  <span>conversions</span>
                  <span>real.</span>
                </div>
              </h3>
            </div>
          </div>
          <div className="outro--full outside">
            <h5 className="big--title">
              This manifesto is for you. To tell you that we found it. We’ve fulfilled your expectations and created the fullest experience on the market. Combining VR, AR, and all those tech acronyms that haven't even been thought of yet.
              <br/><br/>
            </h5>
            <h5 className="big--title">
              Welcome to <span className="green">Full Reality</span>. Where physical not only meets digital, but the two combine into a seamless experience. A never-ending loop of continuous improvement on both sides of the screen.
              <br/><br/>
            </h5>
            <h5 className="big--title">
              From the computer, to the headset, to the shop, and into the shopping cart. No matter where your retail journey takes you or what hot tech trend is on the tip of everyone’s tongue, Full Reality has got you covered.
            </h5>
            <div className="parallax--wrap">
              
            </div>
          </div>
        </StyledFullRealityScroll>
          
      }
    </React.Fragment>
  );
};

export default FullRealityScroll;
